import dayjs from "dayjs";

import { clsxMerge, getCanonicalMeetingTime } from "shared/lib/helpers";
import {
  ACCOUNT_DISPOSITION_STATUSES,
  MEETING_OUTCOMES,
} from "shared/lib/constants/account";

import { DIALER_CALL_STATUS } from "@/constants/dialer";
import { useDialerCallStatus } from "@/hooks/dialer/use-dialer-call-status";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";

import { DisqualifyButton } from "./buttons/disqualify-button";
import { EmailButton } from "./buttons/email-button";
import { ListButton } from "./buttons/list-button";
import { MeetingButton } from "./buttons/meeting-button";
import { MarkMeetingButton } from "./buttons/mark-meeting-button";
import { CallButton } from "./buttons/call-button";
import { MuteButton } from "./buttons/mute-button";
import { DialpadButton } from "./buttons/dialpad-button";
import { ConfigButton } from "./buttons/config-button";

export const AccountDetailsControlMenu = () => {
  const callStatus = useDialerCallStatus();
  const { accountStatus } = useAccountDetailsContext();

  const isMeetingScheduled =
    accountStatus?.status === ACCOUNT_DISPOSITION_STATUSES.MEETING_SCHEDULED;

  // GLE-8044: past-check uses canonical meeting time so ICS-driven reschedules
  // flip MarkMeetingButton visibility correctly.
  const canonicalMeetingTime = accountStatus
    ? getCanonicalMeetingTime(accountStatus)
    : null;
  const isPendingFeedback =
    isMeetingScheduled &&
    !!canonicalMeetingTime &&
    dayjs(canonicalMeetingTime).isBefore(dayjs());

  const isAccountQualified =
    accountStatus?.status === ACCOUNT_DISPOSITION_STATUSES.FEEDBACK_RECEIVED &&
    accountStatus?.meeting_status === MEETING_OUTCOMES.QUALIFIED;

  return (
    <div
      className={clsxMerge(
        "w-max",
        "fixed bottom-5 left-1/2 -translate-x-1/2",
        "rounded-xl bg-black/10 p-3 backdrop-blur-sm",
        "flex items-center gap-x-2"
      )}
    >
      {callStatus === DIALER_CALL_STATUS.BEFORE && <DisqualifyButton />}

      <EmailButton />
      <ListButton />

      {!isAccountQualified && <MeetingButton />}

      {isPendingFeedback && (
        <div data-testid="mark-meeting-button">
          <MarkMeetingButton />
        </div>
      )}

      {callStatus === DIALER_CALL_STATUS.DURING && (
        <>
          <MuteButton />
          <DialpadButton />
          <ConfigButton />
        </>
      )}

      <CallButton />
    </div>
  );
};
